import AuthPageWrapper from "./AuthPageWrapper";
export default AuthPageWrapper;
